module.exports = __webpack_public_path__ + "img/index_04_pic_02@2x.cfa47c97.png";